<template>
    <div
        ref="questionwrapper"
        class="quickscan-question"
    >
        <BackLink
            v-if="current.questionIndex !== 1"
            :is-craft-link="false"
            use-history
        >
            Vorige vraag
        </BackLink>
        <TheQuickscanQuestionCounter
            :current="current.questionIndex"
            :total="maxNrQuestions"
        />
        <h2 class="quickscan-question__title">{{ current.question }}</h2>

        <!-- eslint-disable vue/no-v-html -->
        <div
            class="quickscan-question__details"
            v-html="current.description"
        />
        <!-- eslint-enable vue/no-v-html -->

        <ul class="quickscan-question__answers">
            <li
                v-for="(answer, key) in current?.answers ?? []"
                :key="key"
            >
                <NuxtLink
                    v-slot="{ navigate }"
                    :to="{ name: 'quickscan-slug___nl', params: { slug: [quickscan, answer?.action?.[0]?.slug] }}"
                    custom
                >
                    <BaseButton
                        @click="onClick(answer, navigate)"
                    >
                        {{ answer.answer }}
                    </BaseButton>
                </NuxtLink>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { quickscanTimeline } from './timeline';

const props = defineProps({
    current: {
        type: Object,
        required: true
    },
    maxNrQuestions: {
        type: Number,
        default: 0
    },
    quickscan: {
        type: String,
        required: true
    }
});

const { current } = toRefs(props);

const onClick = async(answer, navigate) => {
    // push to the timeline
    quickscanTimeline.value.push({
        type: 'question',
        question: current.value.question,
        answer: answer.answer
    });

    // navigate!
    return navigate();
};

const questionwrapper = ref(null);

onMounted(() => {
    if (props.current.questionIndex > 1) {
        questionwrapper.value.scrollIntoView(true, {
            behavior: 'smooth'
        });
    }
});
</script>

<style lang="less" src="./Question.less" />
